import React, { useEffect, useState } from "react";
import { ButtonGroup, CustomButton, CustomInput, GridWrapper, Header, SearchBar, SearchSection, Slide, Title, Wrapper} from "./styles";
import Card from "../../components/Card";
import { Swiper } from 'swiper/react';


const Home = () => {
  const [todosImoveis, setTodosImoveis] = useState([]);
  const [gridImoveis, setGridImoveis] = useState([]);
  const [imoveisDestaque, setImoveisDestaque] = useState([]);
  const [erro, setErro] = useState(null);
  const [slidePerView, setSlidePerView] = useState(Math.min(4, Math.max(1, Math.floor(window.innerWidth / 350))));
  const [busca, setBusca] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroFinalidade, setFiltroFinalidade] = useState("");

  const handleBusca = () => {
    const termo = busca.toLowerCase();
    const filtrados = todosImoveis.filter((imovel) =>
      imovel.cidade.toLowerCase().includes(termo) ||
      imovel.tipo.toLowerCase().includes(termo) ||
      imovel.valor.toString().includes(termo)
    );
    setGridImoveis(filtrados);
  };

  const handleBuscaTipo = (termoBotao) => {
    setFiltroTipo(termoBotao.toLowerCase());
  };

  const handleBuscaFinalidade = (termoBotao) => {
    setFiltroFinalidade(termoBotao.toLowerCase());
  };


  useEffect(() => {
    const fetchImoveis = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=imoveis`);
        const data = await res.json();

        if (data.sucesso) {
          setTodosImoveis(data.dados);
          setGridImoveis(data.dados);
          setImoveisDestaque(data.dados.filter((imovel) => imovel.destaque === 1));
        } else {
          setErro(data.erro || "Erro ao carregar imóveis");
        }
      } catch {
        setErro("Erro de conexão com o servidor");
      }
    };

    fetchImoveis();

    const handleResize = () => {
      const novoValor = Math.max(1, Math.floor(window.innerWidth / 320));
      setSlidePerView(novoValor);
    };

    window.addEventListener("resize", handleResize);
    
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    let filtrados = todosImoveis;

    if (filtroTipo) {
      filtrados = filtrados.filter((imovel) =>
        imovel.tipo.toLowerCase().includes(filtroTipo)
      );
    }

    if (filtroFinalidade) {
      filtrados = filtrados.filter((imovel) =>
        imovel.finalidade.toLowerCase().includes(filtroFinalidade)
      );
    }

    setGridImoveis(filtrados);
  }, [filtroTipo, filtroFinalidade, todosImoveis]);

  return (
    <>
      <Header>
        <h2>Imóveis em destaque</h2>
      </Header>
      <Wrapper>
        <Swiper
          slidesPerView={slidePerView}
          spaceBetween={20}
          pagination={{clickable: true}}
          navigation
        >
          {erro && <p>{erro}</p>}
          {imoveisDestaque.map((imovel) => (
            <Slide key={imovel.id}>
              <Card imovel={imovel} />
            </Slide>
          ))}
        </Swiper>
      </Wrapper>

      <SearchSection>
        <Title>Buscar imóveis</Title>
        <ButtonGroup>
          <CustomButton onClick={() => handleBuscaTipo('Casa')}>Casa</CustomButton>
          <CustomButton onClick={() => handleBuscaTipo('Lote')}>Lote</CustomButton>
          <CustomButton onClick={() => handleBuscaTipo('Apartamento')}>Apartamento</CustomButton>
          <CustomButton onClick={() => handleBuscaTipo('Rural')}>Rural</CustomButton>
          <ButtonGroup>
            <CustomButton onClick={() => handleBuscaFinalidade('Comercial')}>Comercial</CustomButton>
            <CustomButton onClick={() => handleBuscaFinalidade('Residencial')}>Residencial</CustomButton>
          </ButtonGroup>          
        </ButtonGroup>
        <SearchBar>
          <CustomInput name="busca" type="text" placeholder="Digite cidade, tipo ou valor..." value={busca} onChange={(e) => setBusca(e.target.value)} />
          <CustomButton onClick={handleBusca}>Buscar</CustomButton>
        </SearchBar>

        <GridWrapper>
          {gridImoveis.map((imovel) => (
            <Card key={imovel.id} imovel={imovel} />
          ))}
        </GridWrapper>
      </SearchSection>

    </>
  );
};

export default Home;